// web/src/api/_csrf.ts
//
// Phase-1 D-14 double-submit CSRF: server sets `csrf_token` cookie
// (non-HttpOnly, intentionally readable by JS) on GET /api/consent/status
// (pre-login) and on login. Every state-changing request must echo
// the cookie value back as the X-CSRF-Token header.
//
// Centralized here so api/* wrappers consume one helper.

export function readCSRFToken(): string {
  const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return m ? decodeURIComponent(m[1]!) : "";
}

export function withCSRF(headers: HeadersInit = {}): HeadersInit {
  const token = readCSRFToken();
  return { ...Object.fromEntries(new Headers(headers)), "X-CSRF-Token": token };
}
